import { AppLayout } from '../../../themes';
import React from 'react';

const DefaultDashboardPage = () => {
	return <AppLayout pageTitle='Dashboard'>DefaultDashboardPage</AppLayout>;
};

export default DefaultDashboardPage;
